import { ServerResponse } from "../../../types/alice-bob";
import { createEffect } from "effector";
import { killApi } from "../api/api";
import { $playerProfile, getCurrentProgress } from "./playerProfile";

export const enemyKilledEffect = createEffect(async (params: { killed: boolean }): Promise<ServerResponse> => {
    const playerProfile = $playerProfile.getState();
    const data = await killApi({ ...params, currentEnergy: playerProfile.player_wallet.currency_energy, alice: playerProfile.hero_alice, currentSoft: playerProfile.player_wallet.currency_soft });
    window.devtodev.customEvent("progress", {
        "stage": data.player.current_stage,
        "chapter": data.player.current_chapter,
        "energy": data.player.player_wallet.currency_energy
    })
    if (data.player.current_chapter > getCurrentProgress()) localStorage.setItem('progress', data.player.current_chapter + "");
    return data;
});

$playerProfile.on(enemyKilledEffect.doneData, (_, payload) => payload.player)

// $currentEnemy.on(enemyKilledEffect.doneData, (_, payload) => {
//     return payload.nextEnemy
// })